/**
 * Joins class names, dropping anything falsy.
 *
 * Deliberately tiny and dependency-free: the kit needs conditional classes, not a utility-class
 * merge strategy, and pulling in a library for `filter(Boolean).join(' ')` is not a trade worth
 * making in a package two applications depend on.
 */
export type ClassValue = string | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
